module.exports = "<h1>SMARTORG</h1>\n<h1>404 Page Not Found</h1>";


//////////////////
// WEBPACK FOOTER
// ./app/404.html
// module id = 233
// module chunks = 0